module.exports = __webpack_public_path__ + "static/media/Source Info.1ac6df04.txt";